import { supabase } from '../lib/supabase';

export interface OpcaoEnquete { id: string; texto: string; }
export interface Enquete {
  id: string;
  pergunta: string;
  descricao: string | null;
  opcoes: OpcaoEnquete[];
  ativa: boolean;
  encerra_em: string | null;
}
export interface ResultadoEnquete {
  total: number;
  por_opcao: Record<string, number>;
}

export const enquetesService = {
  async listarAtivas(estabId: string): Promise<Enquete[]> {
    const { data, error } = await supabase
      .from('enquetes')
      .select('id, pergunta, descricao, opcoes, ativa, encerra_em')
      .eq('estabelecimento_id', estabId)
      .eq('ativa', true)
      .order('criado_em', { ascending: false });
    if (error) throw error;
    return (data ?? []) as Enquete[];
  },

  async meusVotos(cidadaoId: string): Promise<Record<string, string>> {
    const { data } = await supabase
      .from('enquete_votos')
      .select('enquete_id, opcao_id')
      .eq('cidadao_id', cidadaoId);
    const map: Record<string, string> = {};
    (data ?? []).forEach((v) => { const r = v as { enquete_id: string; opcao_id: string }; map[r.enquete_id] = r.opcao_id; });
    return map;
  },

  async votar(enqueteId: string, cidadaoId: string, opcaoId: string): Promise<void> {
    const { error } = await supabase.from('enquete_votos').insert({ enquete_id: enqueteId, cidadao_id: cidadaoId, opcao_id: opcaoId });
    if (error) throw error;
  },

  async resultados(enqueteId: string): Promise<ResultadoEnquete> {
    const { data, error } = await supabase.rpc('enquete_resultados', { p_enquete_id: enqueteId });
    if (error) throw error;
    return (data as ResultadoEnquete) ?? { total: 0, por_opcao: {} };
  },
};
